import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { GetAllFoodLabelResponse } from '@/types/FoodLabel';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const foodLabelsApi = createApi({
  reducerPath: 'foodLabelsApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: `FoodLabel` }),
  tagTypes: ['foodLabels'],
  endpoints: builder => ({
    getFoodLabels: builder.query<GetAllFoodLabelResponse, void>({
      query: () => ({ url: '/GetAllFoodLabelGroup', next: { tags: ['foodLabels'] } }),
      transformResponse: (response: GetAllFoodLabelResponse, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['foodLabels'],
    }),
  }),
});

export const { useGetFoodLabelsQuery } = foodLabelsApi;
